/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */

export default {
    namespaced: true,
    state: () => ({
        participants: 1,
        month: new Date(),
        availableDates: [],
        date: null,
        activeRound: 0,
        confirmed: false,
    }),

    mutations: {
        setMonth(state, month) {
            state.month = month;
        },

        setDate(state, date) {
            state.date = date;
        },
    },
};
